import { Button } from '@material-ui/core';
import headerImage from '../static/cloneBold.jpg';
import { ModalSignUp, ModalSignIn } from './Modals';
import { useContext, useState } from 'react';
import { Link } from "react-router-dom";
import {auth} from './FirebaseConfig';
import {AuthContext} from './context';
import './styles/Header.css'




const Header = () => {
    const [open, setOpen] = useState(false);
    const [openSignIn, setOpenSignIn] = useState(false);
    const { user } = useContext(AuthContext);
    const [uname, setUname] = useState('');

    return(
        <div className = 'header'>
            <Link to = '/' className = 'headerLink'><img className = 'headerImage' src = {headerImage} alt = 'InstaLogo'/></Link>
           

            {user ? (
                        <div>
                            <Link to = '/profile' className = 'headerLink'><Button>{uname ||user.displayName}</Button></Link>
                            <Link to = '/' className = 'headerLink'><Button onClick = {() => auth.signOut()}>Log Out</Button></Link>
                        </div>): 
                        (
                        <div>
                            <Button onClick = {() => setOpenSignIn(true)}>Sign In</Button>
                            <Button onClick = {() => setOpen(true)}>Sign Up</Button>
                        </div>
                        )
            }
        <ModalSignIn openSignIn = {openSignIn} setOpenSignIn = {setOpenSignIn}/>
        <ModalSignUp setUname = {setUname} open = {open} setOpen = {setOpen}/>
        
        </div>
    );
}

export default Header;
